export default __webpack_public_path__ + "static/media/Medium's Bracers of the Kingmaker.e3c68ff9.jpg";